
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immoneuf/ShopFeed",
      function () {
        return require("private-next-pages/immoneuf/ShopFeed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immoneuf/ShopFeed"])
      });
    }
  